module.exports = __webpack_public_path__ + "static/img/xishouye.ed424b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xishouye.png
// module id = +RGX
// module chunks = 21